import { FieldProps } from "../../../Reusables/components/InputFieldsController/InputFieldsController.utils";
import { FormRecord } from "../ClientCreator/ClientCreator.utils";

/**
 * Interface for the props of `ClientEditor`.
 */
export interface ClientEditorProps {
  show: boolean;
  clientData: any;
  formPurpose: string;
  clientMasterId: number;
  disableEdit?: boolean;
  onHide: () => void;
  refresh: () => void;
}

type TabKey = "attest" | "onboarding" | "acceptance";

/**
 * Resets all tab-specific states and closes the modal.
 */
export const handleClose = (
  setClientDetails: (value: any) => void,
  setFormFieldsByTab: React.Dispatch<React.SetStateAction<Record<TabKey, FieldProps[]>>>,
  setSelectedFormByTab: React.Dispatch<React.SetStateAction<Record<TabKey, FormRecord | null>>>,
  onHide: () => void
) => {
  setClientDetails(undefined);
  setFormFieldsByTab({
    attest: [],
    onboarding: [],
    acceptance: [],
  });
  setSelectedFormByTab({
    attest: null,
    onboarding: null,
    acceptance: null,
  });
  onHide(); // Close the modal
};
